import { Component, OnInit } from '@angular/core';
import { ModalService } from 'mis-crystal-design-system/modal';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { DeviceHealthComponent } from '../../device-health/device-health.component';
import { DatePipe } from '@angular/common';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { ITicketDetails } from 'src/app/trip-view-cab/services/common-cab.service';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-trip-info-card',
  templateUrl: './trip-info-card.component.html',
  styleUrls: ['./trip-info-card.component.scss']
})
export class TripInfoCardComponent implements OnInit {
  imgSrc: string;
  constructor(private testPopup: ModalService,private commonService: CommonService, private envService: EnvironmentService) { }
  
  initialState = {type:'SHUTTLE'}
  response:any;
  formattedShiftDate:any;
  formattedActualStartTime:any;
  formattedPlannedStartTime:any;
  formattedStartDate:any;
  formattedEndDate:any;
  formattedActualEndTime:any;
  formattedPlannedEndTime:any;
  shiftDate:any;
  actualStartTime:any;
  actualEndTime:any;
  plannedStartTime:any;
  plannedEndTime:any;
  direction:any;
  womenTravellingAlone=false;
  ticketDetails:ITicketDetails[] = []
  hasDeviceImei: boolean = true;
  isMarshalsRequired:boolean=false;

  ngOnInit(): void {
    this.hasDeviceImei = this.commonService.hasDeviceImei;
    this.imgSrc = this.envService.getImgSrc();
    this.response=this.commonService.response
    this.ticketDetails = this.commonService.ticketDetails
    this.shiftDate= this.response.tripDetails.shift.date
    this.actualStartTime=this.response.tripDetails.actualStartTime
    this.actualEndTime=this.response.tripDetails.actualEndTime
    this.plannedStartTime=this.response.tripDetails.plannedStartTime
    this.plannedEndTime=this.response.tripDetails.plannedEndTime
    this.formattedShiftDate = DateUtils.formatTimeWithZone(this.shiftDate, this.commonService.timeZone, 'ddd DD MMM, HH:mm');
    this.formattedStartDate = DateUtils.formatTimeWithZone(this.actualStartTime, this.commonService.timeZone, 'DD MMM, YY');
    this.formattedActualStartTime = DateUtils.formatTimeWithZone(this.actualStartTime, this.commonService.timeZone, 'HH:mm');
    this.formattedActualEndTime = DateUtils.formatTimeWithZone(this.actualEndTime, this.commonService.timeZone, 'HH:mm');
    this.formattedEndDate = DateUtils.formatTimeWithZone(this.actualEndTime, this.commonService.timeZone, 'DD MMM, YY');
    this.formattedPlannedStartTime = DateUtils.formatTimeWithZone(this.plannedStartTime, this.commonService.timeZone, 'HH:mm');
    this.formattedPlannedEndTime = DateUtils.formatTimeWithZone(this.plannedEndTime, this.commonService.timeZone, 'HH:mm');
    this.isMarshalsRequired=this.response?.tripDetails?.ismarshalRequired;
    this.direction=this.response.tripDetails.direction;
    console.log("response in trip info",this.response,"shift date",this.response.tripDetails.shift.date,"start",this.formattedActualStartTime);
    if(!this.response.tripDetails.driver.driverImagePath){
      this.response.tripDetails.driver.driverImagePath=`${this.imgSrc}assets/icons/driver-profile.svg`;
    }

    this.commonService.womenTravellingAlone$.subscribe((res)=>{
      console.log('womenTravellimgAone',res);
      this.womenTravellingAlone=res;
      
    })

  }


  
  openDeviceHealthModal()
  {
    this.testPopup.show(DeviceHealthComponent, { closeOnBackdropClick: true, ...this.initialState });
  }

  openTicketDetails(ticketUrl:string){
    window.open(ticketUrl, '_blank')
  }


}
